import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './MobileNav.css';

const MobileNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const [showMenu, setShowMenu] = useState(false);

  // Essential navigation items for mobile
  const bottomNavItems = user?.is_merchant ? [
    // Merchant view
    {
      id: 'home',
      label: 'Home',
      icon: '🏠',
      path: '/dashboard'
    },
    {
      id: 'marketplace',
      label: 'Shop',
      icon: '🛒',
      path: '/marketplace'
    },
    {
      id: 'merchant',
      label: 'Merchant',
      icon: '🏪',
      path: '/merchant'
    },
    {
      id: 'collections',
      label: 'Saved',
      icon: '🌟',
      path: '/collections'
    },
    {
      id: 'menu',
      label: 'More',
      icon: '☰',
      action: () => setShowMenu(true)
    }
  ] : [
    // Consumer view
    {
      id: 'home',
      label: 'Home',
      icon: '🏠',
      path: '/dashboard'
    },
    {
      id: 'marketplace',
      label: 'Shop',
      icon: '🛒',
      path: '/marketplace'
    },
    {
      id: 'tryon',
      label: 'Try-On',
      icon: '✨',
      path: '/tryon'
    },
    {
      id: 'collections',
      label: 'Saved',
      icon: '🌟',
      path: '/collections'
    },
    {
      id: 'menu',
      label: 'More',
      icon: '☰',
      action: () => setShowMenu(true)
    }
  ];

  // Additional menu items
  const menuItems = [
    { id: 'models', label: 'My Models', icon: '👤', path: '/models' },
    { id: 'profile', label: 'Profile', icon: '👨', path: '/profile' },
    { id: 'settings', label: 'Settings', icon: '🔧', path: '/settings' },
    ...(user?.is_merchant ? [
      { id: 'merchant', label: 'Merchant Hub', icon: '🏪', path: '/merchant' },
      { id: 'brands', label: 'My Brands', icon: '🏢', path: '/merchant/brands' },
      { id: 'products', label: 'My Products', icon: '📦', path: '/merchant/products' }
    ] : [])
  ];

  const isActive = (path) => {
    return location.pathname === path;
  };

  const handleNavClick = (item) => {
    if (item.action) {
      item.action();
    } else if (item.path) {
      navigate(item.path);
    }
  };

  return (
    <>
      {/* Bottom Navigation Bar */}
      <nav className="mobile-bottom-nav">
        {bottomNavItems.map((item) => (
          <button
            key={item.id}
            className={`mobile-nav-item ${isActive(item.path) ? 'active' : ''}`}
            onClick={() => handleNavClick(item)}
          >
            <span className="mobile-nav-icon">{item.icon}</span>
            <span className="mobile-nav-label">{item.label}</span>
          </button>
        ))}
      </nav>

      {/* Full Menu Overlay */}
      {showMenu && (
        <div className="mobile-menu-overlay" onClick={() => setShowMenu(false)}>
          <div className="mobile-menu" onClick={(e) => e.stopPropagation()}>
            <div className="mobile-menu-header">
              <h2>Menu</h2>
              <button className="close-btn" onClick={() => setShowMenu(false)}>×</button>
            </div>
            
            <div className="mobile-menu-items">
              {menuItems.map((item) => (
                <button
                  key={item.id}
                  className="mobile-menu-item"
                  onClick={() => {
                    navigate(item.path);
                    setShowMenu(false);
                  }}
                >
                  <span className="menu-icon">{item.icon}</span>
                  <span className="menu-label">{item.label}</span>
                  <span className="menu-arrow">›</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MobileNav;